import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import { memo } from "react";
import { CapacityCalendarRowWrapper } from "../capacity-calendar";
import type { CapacityResourceCategory } from "../capacity-resource-categories";

/** Props Interface */
interface CapacityPlannerCategoryRowProps {
	category: CapacityResourceCategory;
}

function CapacityPlannerCategoryRowImpl({ category }: CapacityPlannerCategoryRowProps) {
	/** Hooks */
	const { t } = useTranslation();

	/** Render */
	// The bar that opens a category's section. It spans the whole board rather than drawing the
	// day strip, because a category has no day of its own — the rows beneath it are what stand on
	// the calendar, and those follow once the category's entities are settled.
	return (
		<CapacityCalendarRowWrapper variant="group">
			<div className="h-stack min-w-0 col-span-full">
				<Icon name={category.iconName} />
				<p className="text-sm font-medium truncate">{t(category.labelKey)}</p>
			</div>
		</CapacityCalendarRowWrapper>
	);
}

export const CapacityPlannerCategoryRow = memo(CapacityPlannerCategoryRowImpl);
